import type { FC, ReactNode } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";

interface ActionMenuItemProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  children: ReactNode;
}

/**
 * Пункт меню массовых действий, умеющий показать, что действие идёт.
 *
 * Меню закрывается сразу после клика, поэтому спиннер виден только если
 * пользователь открыл его повторно, пока запрос ещё не вернулся. Основной
 * отклик даёт `ToolbarProgress`, этот спиннер отвечает на вопрос «что
 * именно сейчас выполняется», когда действий в меню несколько.
 */
export const ActionMenuItem: FC<ActionMenuItemProps> = ({
  onClick,
  disabled,
  loading,
  children,
}) => (
  <MenuItem onClick={onClick} disabled={disabled || loading}>
    {children}
    {loading && <CircularProgress size={16} sx={{ ml: 1.5 }} />}
  </MenuItem>
);
